<p-breadcrumb styleClass="p-mt-4" [model]="breadcrumbModel" [home]="home"></p-breadcrumb>
<p-toast position="top-right" key="shipment-details"></p-toast>

<div class="card p-shadow-2 p-mt-3">

    <!--Loader / Spinner-->
    <div>
        <div *ngIf="isLoading" class="p-grid">
            <div class="p-col-12">
                <div class="p-d-flex p-ai-center p-jc-center" style="min-height: 400px">
                    <div class="p-text-center p-text-secondary">
                        <div>
                            <i class="pi pi-spinner pi-spin " style="font-size: 2rem;"></i>
                        </div>
                        <div class="p-mt-3 p-text-bold">
                            <div>Loading Details !</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!isLoading && !shipmentDetails?.builtValues" class="p-grid">
            <div class="p-col-12">
                <div class="p-d-flex p-ai-center p-jc-center"
                     style="min-height: 400px">
                    <div class="p-text-bold p-text-center p-text-secondary">
                        <div>
                            <i class="pi pi-exclamation-triangle" style="font-size: 4rem;"></i> p
                        </div>
                        <div class="p-mt-2">
                            No Details Found !
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--    Shipment Details & Shipment Tracking Components-->
    <div *ngIf="!isLoading && shipmentDetails?.builtValues">
        <div class="p-grid p-ai-start p-jc-between p-mt-0">
            <div class="p-col-12 p-md-9 p-xl-9 p-text-left">
                <div class="divider-bottom p-pb-3">
                    <h5 class="p-m-0 p-text-primary">Shipment Details :
                        ({{shipmentDetails?.shipmentType ? ' ' + shipmentDetails?.shipmentType + ' | ' + (shipmentDetails?.movementType ?
                            shipmentDetails?.movementType : 'N/A') : 'N/A'}})</h5>

                </div>
                <div>
                    <shipment-details [shipmentDetails]="shipmentDetails"></shipment-details>
                </div>
            </div>

            <div class="p-col-12 p-xl-3 p-pl-4">
                <div class="p-text-center p-pb-3">
                    <h5 class="p-m-0 p-text-primary">Shipment Tracking</h5>
                </div>
                <div>
                    <shipment-tracking [trackingDetails]="trackingDetails" [shipmentDetails]="shipmentDetails"
                                       [trackingDetailsArray]="trackingDetailsArray"></shipment-tracking>
                </div>
            </div>

        </div>
    </div>
</div>
